import { useState } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Home, Package, History, User, LogOut, Menu, X, Bell, Shield } from 'lucide-react';

const navItems = [
  { path: '/', label: 'Accueil', icon: Home },
  { path: '/new', label: 'Nouvelle course', icon: Package },
  { path: '/history', label: 'Historique', icon: History },
  { path: '/profile', label: 'Profil', icon: User },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="glass border-b border-border sticky top-0 z-40">
        <div className="container h-16 flex items-center justify-between">
          <Link to="/" className="font-bold text-xl text-primary flex items-center gap-2" style={{textDecoration: 'none'}}>
            <Shield className="w-6 h-6" />
            OuagaLiv
          </Link>
          
          <nav className={`fixed inset-0 bg-background/95 backdrop-blur-sm z-50 flex flex-col p-6 transition-all duration-300 ease-out ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
            <div className="flex justify-between items-center mb-8">
              <Link to="/" className="font-bold text-xl text-primary flex items-center gap-2" style={{textDecoration: 'none'}}>
                <Shield className="w-6 h-6" />
                OuagaLiv
              </Link>
              <button onClick={() => setIsMenuOpen(false)} className="p-2 rounded-lg hover:bg-gray-100 transition-colors" aria-label="Fermer le menu"><X size={24} /></button>
            </div>
            <ul className="space-y-2">
              {navItems.map(item => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl text-lg font-medium transition-all duration-200 ${
                      location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))
                        ? 'bg-primary/10 text-primary'
                        : 'text-text hover:bg-gray-50'
                    }`}
                  >
                    <item.icon size={24} />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-auto pt-6 border-t border-border">
              <p className="text-sm text-text-secondary mb-2">Connecté en tant que</p>
              <p className="font-medium text-text">{user?.fullName}</p>
              <p className="text-xs text-text-secondary capitalize">{user?.role}</p>
              <button onClick={logout} className="btn btn-outline btn-full mt-4">
                <LogOut size={18} /> Déconnexion
              </button>
            </div>
          </nav>

          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      <main className="flex-1 overflow-auto pb-28">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 glass border-t border-border z-40">
        <div className="grid grid-cols-5 max-w-lg mx-auto">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-1 px-2 py-3 transition-all duration-200 ${
                location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))
                  ? 'text-primary'
                  : 'text-text-secondary hover:text-primary'
              }`}
            >
              <item.icon size={24} />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}